<div class="logout-container">
  <div class="logout-content">
    <!-- Icono de logout centrado -->
    <div class="logout-icon-wrapper">
      <svg
        class="logout-icon"
        width="80"
        height="80"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" fill="#2196F3" />
        <path
          d="M9 11V8l7 4-7 4v-3H5v-2h4z"
          fill="white"
        />
      </svg>
    </div>

    <!-- Título y mensaje centrados -->
    <div class="text-center">
      <h1 class="logout-title">Sesión Cerrada</h1>
      <p class="logout-message">
        Has cerrado sesión exitosamente de ClaveÚnica
      </p>
    </div>

    <!-- Nota informativa -->
    <div class="note-card">
      <svg
        class="note-icon"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" stroke="#2196F3" stroke-width="2" />
        <path d="M12 8v4m0 4h.01" stroke="#2196F3" stroke-width="2" />
      </svg>
      <p class="note-text">
        Tu sesión y cookies han sido eliminadas correctamente.
      </p>
    </div>

    <!-- Botón para volver -->
    <button class="btn-primary" (click)="onBackToHome()">
      Volver al Inicio
    </button>
  </div>
</div>
